import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Paper,
  Card,
  Stack,
  FormControl,
  MenuItem,
  Select,
  Button,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress, InputLabel, IconButton,
  OutlinedInput, CardContent,
  TextField, Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../../AuthProvider";
import Swal from "sweetalert2";
import axios from "axios";
import { GlobalStyles } from "@mui/system";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";




// import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";

const baseUrl = process.env.REACT_APP_API_BASE_URL

const Settings = () => {
  const menuItems = [
    "Class Registration",
    "TimeTable Schedule",
    "Receipt Prefix",
    //  "Add Location Radius",
    "Location & Radius",
    "Additional Fee",
    "Hall Ticket",
    "Bonafide",
    "Progress Card",
    "Attendance Type"
  ];

  const [selectedMenu, setSelectedMenu] = useState("Class Registration");

  //Class And section states
  // const [selectedClass, setSelectedClass] = useState("");
  const [selectedSections, setSelectedSections] = useState([]);

  //subject states
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [customSubject, setCustomSubject] = useState("");

  //Examtype state
  const [selectedExamType, setSelectedExamType] = useState([]);
  const [customExamType, setCustomExamType] = useState("");


  const [loading, setLoading] = useState(false);


  const { triggerRefresh, userId, oId, pId, feature, token } = useAuth();
  const selectedUsers = null; // fallback, update as needed
  const UserId = userId || selectedUsers;

  const [tableLoading, settableLoading] = useState(true);
  const [scheduledPeriodsLoading, setScheduledPeriodsLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [tableRowData, setTableRowData] = useState({});

  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isTimetableEditModalOpen, setIsTimetableEditModalOpen] = useState(false);


  const [editClass, setEditClass] = useState("");
  // const [editSections, setEditSections] = useState([]);
  // const [editSubjects, setEditSubjects] = useState([]);
  // const [editExamType, setEditExamType] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);


  const [periodNumber, setPeriodNumber] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [type, setType] = useState("");
  const [timetableData, setTimetableData] = useState([]);


  const [editPeriodNumber, setEditPeriodNumber] = useState("");
  const [editStartTime, setEditStartTime] = useState("");
  const [editEndTime, setEditEndTime] = useState("");
  const [editType, setEditType] = useState("");



  // EDIT DIALOG STATES Set comma-separated string from existing data
  const [rowSectionsInput, setRowSectionsInput] = useState('');
  const [editSubjectsInput, setEditSubjectsInput] = useState('');
  const [editExamTypeInput, setEditExamTypeInput] = useState('');

  const [rowSections, setRowSections] = useState([]);
  const [editSubjects, setEditSubjects] = useState([]);
  const [editExamType, setEditExamType] = useState([]);

  //ADD BOOKSET STATES
  const [itemName, setItemName] = useState("");
  const [amount, setAmount] = useState("");
  const [itemsloading, setItemsLoading] = useState(false);
  const [itemstableLoading, setItemsTableLoading] = useState(true);
  const [itemsTableData, setItemsTableData] = useState([]);
  const [isItemsEditModalOpen, setIsItemsEditModalOpen] = useState(false);
  const [selectedItemRow, setSelectedItemRow] = useState(null);
  const [editItemData, setEditItemData] = useState({ itemNames: "", amount: "" });
  const [isDialogSaveUpdating, setIsDialogSaveUpdating] = useState(false);

  const [sscClassOptions, setSscClassOptions] = useState([]);
  const [sscSelectedClass, setSscSelectedClass] = useState();
  const [tablesscSelectedClass, setTableSscSelectedClass] = useState();


  ///prefixand sequence number settings code
  const [receiptPrefix, setPrefix] = useState("");
  const [startSequence, setSequence] = useState("");
  const [rolePayment, setfeeType] = useState("");
  const [prefixloading, setPrefixLoading] = useState(false);

  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [radius, setRadius] = useState("");
  const [locationLoading, setLocationLoading] = useState(false);
  //sections states
  const [sectionOptions, setSectionOptions] = useState(["Section-A", "Section-B", "Section-C"]);

  const [selectedClass, setSelectedClass] = useState("");
  // const [classOptions, setClassOptions] = useState([
  //   "NURSERY", "LKG", "UKG", "Class-I","Class-II","Class-III","Class-IV","Class-V","Class-VI","Class-VII","Class-VIII","Class-IX","Class-X"
  // ]);

  const [customClass, setCustomClass] = useState("");

  const [examType, setExamType] = useState("");
  const [filterExamType, setFilterExamType] = useState("");
  const [selectedMonths, setSelectedMonths] = useState([]);
  const [monthloading, setMonthloading] = useState(false);
  // for storing the fetched exam types (like 'Monthly', 'Final', etc.)
  const [monthexamTypes, setMonthExamTypes] = useState([]);

  const [monthlyReportsData, setMonthlyReportsData] = useState([]);
  const [reportLoading, setReportLoading] = useState(false);

  const [isMonthEditOpen, setIsMonthEditOpen] = useState(false);
  const [selectedMonthRow, setSelectedMonthRow] = useState(null);

  const [editMonthExamType, setEditMonthExamType] = useState("");
  const [editMonthMonths, setEditMonthMonths] = useState([]);

  const [isUpdatingMonth, setIsUpdatingMonth] = useState(false);



  const handleChange = (event) => {
    const { value } = event.target;
    setSelectedMonths(typeof value === "string" ? value.split(",") : value);
  };


  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];



  //Reportcard select month api
  useEffect(() => {
    const fetchExamTypes = async () => {
      try {

        const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllExamsTypes/${oId}/${pId}`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        // Convert ["A", "B", "C"] to [{ Examtype: "A" }, ...]
        const formattedData = data.map(type => ({ Examtype: type }));
        setMonthExamTypes(formattedData);
      } catch (error) {
        console.error("Error fetching exam types:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchExamTypes();

  }, []);



  // const handlemonthSubmit = async () => {
  //   if (!examType) {
  //     toast.error("Please select Exam Type", { autoClose: 2000 });
  //     return;
  //   }
  //   if (!selectedMonths || selectedMonths.length === 0) {
  //     toast.error("Please select at least one month", { autoClose: 2000 });
  //     return;
  //   }

  //   setMonthloading(true);

  //   try {
  //     // Join months as comma-separated string
  //     const monthsString = selectedMonths.join(",");

  //     // Construct full URL
  //     const url = `${baseUrl}/api/montlyReports/saveMontlyReports/${pId}?examType=${encodeURIComponent(
  //       examType
  //     )}&months=${monthsString}`;

  //     console.log("Request URL:", url);

  //     const response = await fetch(url, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json", // helps some servers accept POST
  //       },
  //       body: null, // explicitly send empty body
  //     });

  //     const contentType = response.headers.get("Content-Type");
  //     let message = "Monthly Report saved successfully!";

  //     if (response.ok) {
  //       if (contentType && contentType.includes("application/json")) {
  //         const data = await response.json();
  //         message = data?.message || message;
  //       } else {
  //         message = await response.text();
  //       }

  //       toast.success(message, { autoClose: 1000 });
  //       // fetchMonthlyReports();
  //       fetchMonthlyReports(filterExamType);
  //       // Reset form
  //       setSelectedMonths([]);
  //       setExamType("");

  //       // Reset filterExamType to first exam type in the list
  //       if (monthexamTypes.length > 0) {
  //         setFilterExamType(monthexamTypes[0].Examtype);
  //       }

  //       // Refresh table after submit
  //       setFilterExamType(monthexamTypes[0].Examtype);
  //       fetchMonthlyReports();

  //     } else {
  //       const errorMsg = await response.text();
  //       throw new Error(errorMsg || `Failed with status: ${response.status}`);
  //     }
  //   } catch (error) {
  //     console.error("Error submitting monthly report:", error);
  //     toast.error(error.message || "Failed to save monthly report!", { autoClose: 2000 });
  //   } finally {
  //     setMonthloading(false);
  //   }
  // };


  // Get Method for Monthly Reports
  const fetchMonthlyReports = async (selectedExamType) => {
    setReportLoading(true);
    try {
      const monthsString = selectedMonths.join(",");

      // use selectedExamType instead of state examType
      const url = `${baseUrl}/api/montlyReports/getMontlyReports/${pId}`;

      console.log("📦 Fetching Monthly Reports:", url);

      const response = await fetch(url);
      const data = await response.json();

      if (response.ok) {
        if (Array.isArray(data)) {
          setMonthlyReportsData(data);
        } else if (data && typeof data === "object") {
          setMonthlyReportsData([data]);
        } else {
          setMonthlyReportsData([]);
        }
      } else {
        console.error("API Error:", response.status, data);
        setMonthlyReportsData([]);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setMonthlyReportsData([]);
    } finally {
      setReportLoading(false);
    }
  };

  useEffect(() => {
    fetchMonthlyReports();
  }, []);


  const handlemonthSubmit = async () => {
    if (!examType) {
      toast.error("Please select Exam Type", { autoClose: 2000 });
      return;
    }
    if (!selectedMonths || selectedMonths.length === 0) {
      toast.error("Please select at least one month", { autoClose: 2000 });
      return;
    }

    setMonthloading(true);

    try {
      const monthsString = selectedMonths.join(",");
      const url = `${baseUrl}/api/montlyReports/saveMontlyReports/${pId}?examType=${encodeURIComponent(
        examType
      )}&months=${monthsString}`;

      console.log("Request URL:", url);

      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: null,
      });

      const contentType = response.headers.get("Content-Type");
      let message = "Monthly Report saved successfully!";

      if (response.ok) {
        if (contentType && contentType.includes("application/json")) {
          const data = await response.json();
          message = data?.message || message;
        } else {
          message = await response.text();
        }
        toast.success(message, { autoClose: 1000 });
        setSelectedMonths([]);
        setExamType("");
        // if (monthexamTypes.length > 0) {
        //   setFilterExamType(monthexamTypes[0].Examtype);
        // }
        fetchMonthlyReports();
      } else {
        let errorMsg = "Failed to save monthly report!";
        if (contentType && contentType.includes("application/json")) {
          const data = await response.json();
          errorMsg = data?.message || errorMsg;
        } else {
          errorMsg = await response.text();
        }
        toast.error(errorMsg, { autoClose: 2000 });
      }
    } catch (error) {
      console.error("Error submitting monthly report:", error);
      toast.error(error.message || "Failed to save monthly report!", { autoClose: 2000 });
    } finally {
      setMonthloading(false);
    }
  };

  const handleOpenMonthEdit = (row) => {
    setSelectedMonthRow(row);
    setEditMonthExamType(row.examType || "");
    setEditMonthMonths(row.months ? row.months.split(",") : []);
    setIsMonthEditOpen(true);
  };


  const handleUpdateMonthRow = async (updatedRow) => {
    try {
      setIsUpdatingMonth(true);

      // Construct query params
      const queryParams = new URLSearchParams({
        examType: updatedRow.examType,
        months: Array.isArray(updatedRow.months)
          ? updatedRow.months.join(",")
          : updatedRow.months,
      }).toString();

      // API endpoint with query params
      const url = `${baseUrl}/api/montlyReports/monthly-reports/${updatedRow.id}?${queryParams}`;

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const contentType = response.headers.get("Content-Type");
      let message = "Monthly report updated successfully!";

      if (response.ok) {
        if (contentType && contentType.includes("application/json")) {
          const data = await response.json();
          message = data?.message || message;
        } else {
          message = await response.text();
        }

        toast.success(message, { autoClose: 1500 });

        // Refresh table data after update
        fetchMonthlyReports();

        // Close modal
        setIsMonthEditOpen(false);
        setSelectedMonthRow(null);
      } else {
        const errorText = await response.text();
        throw new Error(errorText || `Failed with status: ${response.status}`);
      }
    } catch (error) {
      console.error("Patch update error:", error);
      toast.error(error.message || "Failed to update monthly report!");
    } finally {
      setIsUpdatingMonth(false);
    }
  };



  const handleRemoveMonthRow = async (monthRow) => {
    if (!monthRow.id) {
      toast.error("Invalid row. Please select a valid row to delete.");
      return;
    }

    // Show confirmation dialog
    Swal.fire({
      title: "Are you sure?",
      text: `You want to delete the report for ${monthRow.examType}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          console.log("Deleting monthly report with ID:", monthRow.id);

          // Send DELETE request to API
          const response = await fetch(
            `${baseUrl}/api/montlyReports/deleteMontlyReports/${monthRow.id}`,
            { method: "DELETE" }
          );

          if (!response.ok) {
            throw new Error("Failed to delete the monthly report. Please try again.");
          }

          // Show success toast
          toast.success(`${monthRow.examType} report deleted successfully!`, { autoClose: 1500 });

          // Refresh table data after deletion
          fetchMonthlyReports();

        } catch (error) {
          console.error("Error deleting monthly report:", error);
          toast.error(`Error deleting report: ${error.message}`);
        }
      }
    });
  };

  // useEffect(() => {
  //     if (monthexamTypes.length > 0) {
  //       const defaultExam = monthexamTypes[0].Examtype;
  //       setFilterExamType(defaultExam);
  //     }
  //   }, [monthexamTypes]);





  //Location and Radius PATCH API
  const handleLocationSave = async () => {
    // if (!latitude || !longitude || !radius) {
    //   toast.error("All fields are required", { position: "top-right", autoClose: 1000 });
    //   return;
    // }
    if (!latitude) {
      toast.error("Latitude is required", { position: "top-right", autoClose: 1000 });
      return;
    }

    if (!longitude) {
      toast.error("Longitude is required", { position: "top-right", autoClose: 1000 });
      return;
    }

    if (!radius) {
      toast.error("Radius is required", { position: "top-right", autoClose: 1000 });
      return;
    }

    const queryParams = new URLSearchParams({
      latitude,
      longitude,
      radius,
    }).toString();

    setLocationLoading(true);

    try {
      const response = await fetch(`${baseUrl}/api/principal/updateLocationAndRadius/${pId}?${queryParams}`, {
        method: "PATCH",
      });

      if (response.ok) {
        toast.success("Location and Radius updated successfully!", { position: "top-right", autoClose: 1000 });

        // ✅ Clear input fields
        // setLatitude("");
        // setLongitude("");
        // setRadius("");
        handleGetLocationDetails();

      } else {
        const errorText = await response.text();
        toast.error(errorText || "Failed to update location data.", { position: "top-right", autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong!", { position: "top-right", autoClose: 2000 });
    } finally {
      setLocationLoading(false);
    }
  };

  //get method for location , radius 
  const handleGetLocationDetails = async () => {
    if (!pId) return;

    setLocationLoading(true);

    try {
      const response = await fetch(
        `${baseUrl}/api/principal/get/details/Latlong/${pId}`

      );

      if (response.ok) {
        const data = await response.json();

        // ✅ Set values from API response
        setLatitude(data.latitude ?? "");
        setLongitude(data.longitude ?? "");
        setRadius(data.radius ?? "");
      } else {
        console.error("Failed to fetch location data");
      }
    } catch (error) {
      console.error("Error while fetching location:", error);
    } finally {
      setLocationLoading(false);
    }
  };


  useEffect(() => {
    handleGetLocationDetails();
  }, [pId]);



  //SUBMIT
  const handleSubmit = async () => {
    if (!receiptPrefix) {
      toast.error("Please enter Prefix", { autoClose: 2000 });
      return;
    }
    if (!startSequence) {
      toast.error("Please enter Start Sequence", { autoClose: 2000 });
      return;
    }
    if (!rolePayment) {
      toast.error("Please select Category Type", { autoClose: 2000 });
      return;
    }

    setPrefixLoading(true);

    try {
      const queryParams = new URLSearchParams({
        receiptPrefix,
        startSequence,
        rolePayment,
      });

      const response = await fetch(
        `${baseUrl}/api/principal/setReceiptPrefix/${pId}?${queryParams.toString()}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const contentType = response.headers.get("Content-Type");

      let message = "Prefix Updated successfully!";
      if (response.ok) {
        if (contentType && contentType.includes("application/json")) {
          const data = await response.json();
          message = data?.message || message;
        } else {
          message = await response.text();
        }
        toast.success(message, { autoClose: 1000 });
      } else {
        const errorMsg = await response.text();
        throw new Error(errorMsg || `Failed with status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error(error.message || "Failed to update!", { autoClose: 2000 });
    } finally {
      setPrefixLoading(false);
    }
  };


  //bookset classes get function
  //classes list api function
  const fetchClassRegistrationData = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`
      );
      const data = await response.json();

      if (response.ok && Array.isArray(data)) {
        const classSectionMap = {};

        data.forEach((item) => {
          const className = item.classRegistration;
          const sections = item.sections.split(",").map((s) => s.trim());

          if (!classSectionMap[className]) {
            classSectionMap[className] = new Set();
          }

          sections.forEach((sec) => classSectionMap[className].add(sec));
        });

        const classes = Object.keys(classSectionMap);
        setSscClassOptions(classes);

        if (classes.length) {
          const defaultClass = classes[0];

          setTableSscSelectedClass(defaultClass);
        } else {
          setSscSelectedClass("");
        }
      }
    } catch (error) {
      console.error("Error fetching SSC data:", error);
    }
  };

  useEffect(() => {
    fetchClassRegistrationData();
  }, []);



  // bookset post code
  const handleSubmitItem = async () => {
    if (!sscSelectedClass) {
      toast.error("Select At least One Class", { autoClose: 2000 });
      return;
    }
    if (!itemName) {
      toast.error("Please Enter Item Name", { autoClose: 2000 });
      return;
    }
    if (!amount) {
      toast.error("Please Enter Amount", { autoClose: 2000 });
      return;
    }

    setItemsLoading(true);

    try {
      const queryParams = new URLSearchParams({
        romanNumberClass: sscSelectedClass,
        itemNames: itemName,
        pricePerItemAmount: amount.toString(),
      });

      const response = await fetch(
        `${baseUrl}/api/additionalFee/create/${oId}/${pId}?${queryParams.toString()}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success("Item added successfully!", { autoClose: 1000 });
        fetchItemsTableData();
        setItemName("");
        setAmount("");
      } else {
        toast.error(`Error: ${data.message || "Something went wrong"}`, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      toast.error(`Request failed: ${error.message}`, {
        autoClose: 2000,
      });
    } finally {
      setItemsLoading(false);
    }
  };


  //bookset get code
  // Get Method For Registered Classes
  const fetchItemsTableData = async () => {
    if (!tablesscSelectedClass) return;
    setItemsTableLoading(true);
    try {
      const response = await fetch(`${baseUrl}/api/additionalFee/getAll/${pId}/${tablesscSelectedClass}`);
      const data = await response.json();

      if (response.ok && Array.isArray(data)) {
        setItemsTableData(data);
      } else {
        console.warn("No data found or invalid format:", data);
        setItemsTableData([]);
      }
    } catch (error) {
      console.error("Error loading class table:", error);
      setItemsTableData([]);
    } finally {
      setItemsTableLoading(false);
    }
  };

  useEffect(() => {
    fetchItemsTableData();
  }, [oId, pId, tablesscSelectedClass]);


  //edit bookset code
  // When opening modal, set editItemData
  const handleItemsEditRow = (rowData) => {
    setSelectedItemRow(rowData);
    setEditItemData({
      itemNames: rowData.itemNames || "",
      amount: rowData.pricePerItemAmount || "",
    });
    setIsItemsEditModalOpen(true);
  };

  // item update handler function
  const handleSaveEditedItem = async () => {
    if (!selectedItemRow?.id) return;

    setIsDialogSaveUpdating(true);

    try {
      const queryParams = new URLSearchParams({
        itemNames: editItemData.itemNames,
        pricePerItemAmount: editItemData.amount.toString(),
      });

      const response = await fetch(
        `${baseUrl}/api/additionalFee/update/${selectedItemRow.id}?${queryParams.toString()}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success("Item updated successfully", { autoClose: 1000 });
        setIsItemsEditModalOpen(false);
        fetchItemsTableData();
      } else {
        toast.error(`Error: ${data.message || "Update failed"}`, { autoClose: 2000 });
      }
    } catch (err) {
      toast.error(`Request failed: ${err.message}`, { autoClose: 2000 });
    } finally {
      setIsDialogSaveUpdating(false);
    }
  };


  //delete items functionality
  const handleItemsDeleteRow = async (row) => {
    if (!row.id) {
      toast.error("Invalid row. Please select a valid row to delete.");
      return;
    }

    // Show SweetAlert2 confirmation
    Swal.fire({
      title: "Are you sure?",
      // text: `You Want Delete the Item ${row.itemNames}`,
      html: `You want to delete the item <strong>${row.itemNames}</strong>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          console.log("Deleting row with ID:", row.id);

          // Send DELETE request to API
          const response = await fetch(
            `${baseUrl}/api/additionalFee/delete/${row.id}`,
            { method: "DELETE" }
          );

          if (!response.ok) {
            throw new Error("Failed to delete the row. Please try again.");
          }

          // Show success toast
          toast.success(`${row.itemNames} Deleted Successfully!`, { autoClose: 1000 });
          fetchItemsTableData();
        } catch (error) {
          // console.error("Error deleting row:", error);
          toast.error(`Error deleting row: ${error.message}`);
        }
      }
    });
  };








  useEffect(() => {
    if (selectedRow) {
      const safeSplit = (str) =>
        str
          ?.replace(/([a-z])([A-Z])/g, '$1,$2') // Optional: fix malformed strings
          .split(',')
          .map((item) => item.trim())
          .filter((item) => item !== '');

      const classSections = selectedRow.classSectionLimit || '';
      const subjects = selectedRow.allSubject || '';
      const examTypes = selectedRow.examTypes || '';

      setRowSections(safeSplit(classSections));
      setEditSubjects(safeSplit(subjects));
      setEditExamType(safeSplit(examTypes));

      setRowSectionsInput(classSections);
      setEditSubjectsInput(subjects);
      setEditExamTypeInput(examTypes);
    }
  }, [selectedRow]);

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
  };



  // useEffect(() => {
  //   if (selectedMenu === "Class Registration") {
  //     fetchTableData();
  //   }else if(selectedMenu === "Timetable Scheduling") {
  //     fetchScheduledPeriods();
  //   }
  // }, [selectedMenu, oId, baseUrl]);

  // useEffect for menu-based data fetching
  useEffect(() => {
    if (!oId) return; // Ensure oId is present

    if (selectedMenu === "Class Registration") {
      fetchTableData();
    } else if (selectedMenu === "TimeTable Schedule") {
      fetchScheduledPeriods();
    } else {
      setTableData([]); // Optional: clear table if menu doesn't match
    }
  }, [oId, selectedMenu]);



  const headerStyle = {
    borderRight: "1px solid #ddd",
    padding: "6px",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#fff9c4",
  };
  const cellStyle = {
    borderRight: "1px solid #ddd",
    padding: "6px",
    textAlign: "center"
  };

  // const classOptions = [
  //   "Nursery",
  //   "LKG",
  //   "UKG",
  //   ...Array.from({ length: 12 }, (_, i) => `Class ${i + 1}`),
  // ];
  // const romanNumerals = [
  //   "I", "II", "III", "IV", "V", "VI",
  //   "VII", "VIII", "IX", "X"
  // ];

  // const classOptions = [
  //   "NURSERY",
  //   "LKG",
  //   "UKG",
  //   ...romanNumerals.map((num) => `Class-${num}`),
  // ];






  // const handleAddClass = () => {
  //   const trimmed = customClass.trim();
  //   if (trimmed && !classOptions.includes(trimmed)) {
  //     setClassOptions((prev) => [...prev, trimmed]);
  //     setSelectedClass(trimmed); // Set newly added class as selected
  //     setCustomClass("");
  //   }
  // };



  // const [selectedClass, setSelectedClass] = useState("");
  // const [classOptions, setClassOptions] = useState(["Nursery", "LKG", "UKG", "Class 1"]);
  // const [customClass, setCustomClass] = useState("");

  // const handleAddClass = () => {
  //   const trimmed = customClass.trim();
  //   if (trimmed && !classOptions.includes(trimmed)) {
  //     setClassOptions((prev) => [...prev, trimmed]);
  //     setSelectedClass(trimmed);
  //     setCustomClass("");
  //   }
  // };










  //OLD CODE
  const romanNumerals = [
    "I", "II", "III", "IV", "V", "VI",
    "VII", "VIII", "IX", "X"
  ];

  const classOptions = [
    "NURSERY",
    "LKG",
    "UKG",
    ...romanNumerals.map((num) => `Class-${num}`),
  ];


  const [subjectOptions, setSubjectOptions] = useState([]);

  useEffect(() => {
    // if (!selectedClass) return;

    let subjects = [];

    if (selectedClass.toUpperCase() === "NURSERY") {
      subjects = ["Rhymes", "Drawing", "GK"];
    } else if (selectedClass.toUpperCase() === "LKG") {
      subjects = ["EVS", "GK", "Drawing"];
    } else if (selectedClass.toUpperCase() === "UKG") {
      subjects = ["EVS", "GK", "Drawing"];
    } else if (
      ["CLASS-I", "CLASS-II", "CLASS-III", "CLASS-IV", "CLASS-V"].includes(selectedClass.toUpperCase())
    ) {
      subjects = ["EVS", "ENGLISH", "MATHS", "TELUGU", "HINDI", "GK"];
    } else if (
      ["CLASS-VI", "CLASS-VII", "CLASS-VIII", "CLASS-IX", "CLASS-X"].includes(selectedClass.toUpperCase())
    ) {
      subjects = [
        "TELUGU",
        "HINDI",
        "ENGLISH",
        "MATHS",
        "SCIENCE",
        "SOCIAL",
        "PHYSICS",
        "CHEMISTRY",
        "GK",
      ];
    } else {
      // fallback to empty or default subjects if needed
      subjects = [
        "TELUGU",
        "HINDI",
        "ENGLISH",
        "MATHS",
        "SCIENCE",
        "SOCIAL",
        "PHYSICS",
        "CHEMISTRY",
        "GK",
      ];
    }

    setSubjectOptions(subjects);
  }, [selectedClass]);

  const handleAddSubject = () => {
    const trimmed = customSubject.trim().toUpperCase(); // Convert to uppercase
    if (trimmed && !subjectOptions.includes(trimmed)) {
      setSubjectOptions((prev) => [...prev, trimmed]);
      setSelectedSubjects((prev) => [...prev, trimmed]);
    }
    setCustomSubject("");
  };


  const handleToggle = (subject) => {
    setSelectedSubjects((prev) =>
      prev.includes(subject)
        ? prev.filter((s) => s !== subject)
        : [...prev, subject]
    );
  };

  const handleSelectAll = () => {
    if (selectedSubjects.length === subjectOptions.length) {
      setSelectedSubjects([]);
    } else {
      setSelectedSubjects(subjectOptions);
    }
  };

  const handleRemoveSubject = (subject) => {
    setSubjectOptions((prev) => prev.filter((s) => s !== subject));
    setSelectedSubjects((prev) => prev.filter((s) => s !== subject));
  };



  const [examTypes, setExamTypes] = useState([
    "FA-1",
    "FA-2",
    "FA-3",
    "FA-4",
    "SA-1",
    "SA-2",
  ]);

  const handleAddExamType = () => {
    const trimmed = customExamType.trim();
    if (trimmed && !examTypes.includes(trimmed)) {
      setExamTypes((prev) => [...prev, trimmed]);
      setSelectedExamType((prev) => [...prev, trimmed]);
    }
    setCustomExamType("");
  };

  const handleExamTypeToggle = (type) => {
    setSelectedExamType((prev) =>
      prev.includes(type)
        ? prev.filter((t) => t !== type)
        : [...prev, type]
    );
  };

  const handleExamTypeSelectAll = () => {
    if (selectedExamType.length === examTypes.length) {
      setSelectedExamType([]);
    } else {
      setSelectedExamType(examTypes);
    }
  };

  const handleRemoveType = (type) => {
    setExamTypes((prev) => prev.filter((t) => t !== type));
    setSelectedExamType((prev) => prev.filter((t) => t !== type));
  };


  // Class Registration Post Method
  const handleRegisterClass = async () => {
    if (!selectedClass) {
      toast.error("Please select a Class");
      return;
    }

    if (selectedSections.length === 0) {
      toast.error("Please select at least one Section");
      return;
    }


    if (selectedSubjects.length === 0) {
      toast.error("Please select at least one Subject");
      return;
    }

    if (selectedExamType.length === 0) {
      toast.error("Please select an Exam Types");
      return;
    }

    const formData = new FormData();

    formData.append("userId", UserId);
    formData.append("classRegistration", selectedClass);
    formData.append("examType", selectedExamType);

    selectedSections.forEach((section) => {
      formData.append("classSectionLimit", section);
    });

    const finalSubjects =
      selectedSubjects.includes("Other") && customSubject
        ? [...selectedSubjects.filter((s) => s !== "Other"), customSubject]
        : selectedSubjects;

    finalSubjects.forEach((subject) => {
      formData.append("allSubject", subject);
    });

    try {
      setLoading(true);

      const response = await fetch(
        `${baseUrl}/api/dynamic-classReg/saveRegClass/${oId}/${pId}`,
        {
          method: "POST",
          body: formData,
        }
      );

      // const result = await response.json();

      const responseData = await response.text();

      if (response.ok) {
        toast.success(`${selectedClass} Registered Successful!`, { autoClose: 1000 });
        fetchTableData();

        // Refresh Examtype list in side bar
        // setRefreshKey((prev) => prev + 1);
        triggerRefresh("examTypes"); // only re-fetch quiz types

        setSelectedClass("");
        setSelectedSections([]);
        setSelectedSubjects([]);
        setSelectedExamType([]);
        setCustomSubject("");
      } else {
        toast.error(responseData || "Something went wrong!");
      }
    } catch (error) {
      toast.error("Network error. Please try again.");
      console.error("Error submitting:", error);
    } finally {
      setLoading(false);
    }
  };



  // Get Method For Registered Classes
  const fetchTableData = async () => {
    settableLoading(true);
    try {
      const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllRegClass/${oId}/${pId}`);
      const data = await response.json();

      if (response.ok && Array.isArray(data)) {
        setTableData(data);
      } else {
        console.warn("No data found or invalid format:", data);
        setTableData([]);
      }
    } catch (error) {
      console.error("Error loading class table:", error);
      setTableData([]);
    } finally {
      settableLoading(false);
    }
  };




  // Edit CLASS TABLE CODE
  const safeSplit = (str) =>
    str
      ?.split(',')
      .map((item) => item.trim())
      .filter((item) => item !== '');

  const handleBlur = () => {
    setRowSections(safeSplit(rowSectionsInput));
    setEditSubjects(safeSplit(editSubjectsInput));
    setEditExamType(safeSplit(editExamTypeInput));
  };

  const handleEditRow = (rowData) => {
    setSelectedRowId(rowData.id);
    setSelectedRow(rowData);
    setEditClass(rowData.classRegistration);

    setRowSections(safeSplit(rowData.classSectionLimit)); // ✅ fix here
    setEditSubjects(safeSplit(rowData.allSubject));
    setEditExamType(safeSplit(rowData.examTypes));

    setIsEditModalOpen(true);
  };





  const handleEditTimetableRow = (row) => {
    setSelectedRow(row);
    setEditPeriodNumber(row.periodNumber);
    setEditStartTime(row.startTime);
    setEditEndTime(row.endTime);
    setEditType(row.type);
    setIsTimetableEditModalOpen(true);
  };

  // Edit  Function
  const handleUpdateRow = async () => {
    if (!selectedRow) {
      toast.error("No row selected for update.");
      return;
    }
    setIsUpdating(true); // <-- Start loading

    try {
      const formData = new FormData();

      formData.append("classRegistration", editClass);
      formData.append("classSectionLimit", rowSections.join(","));
      formData.append("allSubject", editSubjects.join(","));
      formData.append("examTypes", editExamType);

      const response = await fetch(
        `${baseUrl}/api/dynamic-classReg/partialUpdateRegClass/${selectedRow.id}/${oId}/${pId}`,
        {
          method: "PATCH",
          body: formData,
        }
      );

      let responseData;
      try {
        responseData = await response.text(); // Handle plain text response
      } catch (textError) {
        console.error("Error parsing response as text:", textError);
        responseData = "Unknown error occurred.";
      }

      if (!response.ok) {
        throw new Error(responseData); // Directly throw text error
      }

      toast.success("Row updated successfully!", { autoClose: 1000 });

      // Optionally re-fetch table data from backend here
      fetchTableData();

      // Refresh Examtype list in side bar
      // setRefreshKey((prev) => prev + 1);

      // after successful POST or PATCH:
      triggerRefresh("examTypes"); // only re-fetch quiz types

      setSelectedRow(null);
      setIsEditModalOpen(false);
    } catch (error) {
      console.error("Error updating row:", error);
      toast.error(error.message, { autoClose: 3000 });
    } finally {
      setIsUpdating(false); // <-- Stop loading
    }
  };



  // Class Reegistration Delete Function code
  const handleDeleteRow = async (row) => {
    if (!row.id) {
      toast.error("Invalid row. Please select a valid row to delete.");
      return;
    }

    // Show SweetAlert2 confirmation
    Swal.fire({
      title: "Are you sure?",
      text: `You Want Delete the ${row.classRegistration}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          console.log("Deleting row with ID:", row.id);

          // Send DELETE request to API
          const response = await fetch(
            `${baseUrl}/api/dynamic-classReg/deleteById/${row.id}/${oId}/${pId}`,
            { method: "DELETE" }
          );

          if (!response.ok) {
            throw new Error("Failed to delete the row. Please try again.");
          }

          // Show success toast
          toast.success(`${row.classRegistration} Deleted Successfully!`, { autoClose: 1000 });

          // Remove the row from state after successful deletion
          fetchTableData();
          // Refresh Examtype list in side bar
          // setRefreshKey((prev) => prev + 1);
          triggerRefresh("examTypes"); // only re-fetch quiz types


          // Show SweetAlert success message
          // Swal.fire("Deleted!", "Row has been deleted.", "success");
        } catch (error) {
          // console.error("Error deleting row:", error);
          toast.error(`Error deleting row: ${error.message}`);
        }
      }
    });
  };





  // Timetable Scheduling
  const handleTimetableSubmit = async () => {

    if (
      selectedType !== "Interval Break" &&
      selectedType !== "Lunch Break" &&
      !periodNumber
    ) {
      toast.error("Please select a Period Number");
      return;
    }


    if (!startTime) {
      toast.error("Please select a Start Time");
      return;
    }

    if (!endTime) {
      toast.error("Please select an End Time");
      return;
    }

    if (!selectedType) {
      toast.error("Please select a Type");
      return;
    }



    const formData = new FormData();
    formData.append("userId", UserId); // Assuming `UserId` is already defined
    formData.append("periodNumber", periodNumber);
    formData.append("startTime", startTime);
    formData.append("endTime", endTime);
    formData.append("type", selectedType);

    try {
      setLoading(true);

      const response = await fetch(
        `${baseUrl}/api/dynamic-time-table/save/${oId}/${pId}`, // Replace endpoint as needed
        {
          method: "POST",
          body: formData,
        }
      );

      const responseData = await response.text();

      if (response.ok) {
        toast.success("Period scheduled successfully!", { autoClose: 1000 });
        // Optionally fetch fresh table data
        fetchScheduledPeriods();

        // Reset form
        setPeriodNumber("");
        setStartTime("");
        setEndTime("");
        setSelectedType("");
      } else {
        toast.error(responseData || "Something went wrong!", { autoClose: 2000 });
      }
    } catch (error) {
      toast.error("Network error. Please try again.");
      console.error("Error submitting timetable:", error);
    } finally {
      setLoading(false);
    }
  };


  // GetMethod For Scheduled Periods
  const fetchScheduledPeriods = async () => {
    setScheduledPeriodsLoading(true);
    try {
      const response = await fetch(
        // `${baseUrl}/api/dynamic-time-table/getAllTimeSlots/${oId}`
        `${baseUrl}/api/dynamic-time-table/getAllTimeTableDetails/${oId}/${pId}`
      );
      const data = await response.json();

      console.log("API Response:", data); // ✅ Debug API Response

      if (response.ok) {
        setTimetableData(data); // ✅ Directly setting the array
      } else {
        console.warn("No data found:", data); // ✅ Log if empty
        setTimetableData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setTimetableData([]);
    } finally {
      setScheduledPeriodsLoading(false);
    }
  };

  // Scheduled Periods update API
  const handleUpdateTimetableRow = async () => {
    if (!selectedRow) {
      toast.error("No row selected for update.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("periodNumber", editPeriodNumber);
      formData.append("startTime", editStartTime);
      formData.append("endTime", editEndTime);
      formData.append("type", editType);

      const response = await fetch(
        `${baseUrl}/api/dynamic-time-table/partialUpdate/${selectedRow.id}/${oId}/${pId}`,
        {
          method: "PATCH",
          body: formData,
        }
      );

      let responseData;
      try {
        responseData = await response.text();
      } catch (textError) {
        console.error("Error parsing response as text:", textError);
        responseData = "Unknown error occurred.";
      }

      if (!response.ok) {
        throw new Error(responseData);
      }

      toast.success("Timetable entry updated successfully!", { autoClose: 1000 });

      // Update the table data with new values
      setTableData((prevData) =>
        prevData.map((row) =>
          row.id === selectedRow.id
            ? {
              ...row,
              periodNumber: editPeriodNumber,
              startTime: editStartTime,
              endTime: editEndTime,
              type: editType,
            }
            : row
        )
      );

      setSelectedRow(null);
      setIsTimetableEditModalOpen(false);
    } catch (error) {
      console.error("Error updating timetable entry:", error);
      toast.error(error.message, { autoClose: 3000 });
    }
  };


  // Scheduled Periods delete action
  const handleDeleteScheduledPeriod = async (row) => {

    if (!row.id) {
      toast.error("Invalid row. Please select a valid row to delete.");
      return;
    }


    // Show SweetAlert2 confirmation
    Swal.fire({
      title: "Are you sure?",
      text: `You want to delete Period "${row.periodNumber}"`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          console.log("Deleting row with ID:", row.id);


          // Send DELETE request to API
          const response = await fetch(
            `${baseUrl}/api/dynamic-time-table/delete/${row.id}`,
            { method: "DELETE" }
          );

          if (!response.ok) {
            throw new Error("Failed to delete the row. Please try again.");
          }

          // Show success toast
          toast.success(`Period ${row.periodNumber} deleted successfully!`, { autoClose: 1000 });
          fetchScheduledPeriods();

        } catch (error) {
          console.error("Deletion error:", error);
          toast.error(`Error deleting row: ${error.message}`);
        }
      }
    });
  };
  const [typeOptions, setTypeOptions] = useState([
    "Period",
    "Interval Break",
    "Lunch Break",
  ]);
  const [selectedType, setSelectedType] = useState("");
  const [customType, setCustomType] = useState("");
  const [open, setOpen] = useState(false); // manually control select open/close

  const handleAddType = () => {
    const newType = customType.trim();
    if (newType && !typeOptions.includes(newType)) {
      setTypeOptions([...typeOptions, newType]);
      setSelectedType(newType);
    }
    setCustomType("");
  };

  const handleRemoveScheduledType = (value) => {
    setTypeOptions(typeOptions.filter((v) => v !== value));
    if (selectedType === value) setSelectedType("");
  };


  // Hall Ticket Theme Selector

  const [selectedHallTheme, setSelectedHallTheme] = useState("HallTicketTemplate");
  const [previewHallTheme, setPreviewHallTheme] = useState(null);
  const [openHallPreview, setOpenHallPreview] = useState(false);
  const [hallThemeLoading, setHallThemeLoading] = useState(false);

  // Bonafide Theme Selector

  const [selectedBonafideTheme, setSelectedBonafideTheme] = useState("Bonafide2");
  const [previewBonafideTheme, setPreviewBonafideTheme] = useState(null);
  const [openBonafidePreview, setOpenBonafidePreview] = useState(false);
  const [bonafideThemeLoading, setBonafideThemeLoading] = useState(false);



  // ================== SAVE TO API ==================
  const handleSaveHallTheme = async (themeId) => {
    if (!themeId) return;
    setHallThemeLoading(true);

    try {
      const response = await fetch(
        `${baseUrl}/api/principal/saveTheme/${pId}?hallTicketTheme=${themeId}`,
        {
          method: "POST",

        }
      );

      const data = await response.text(); // backend returns plain text

      if (response.ok) {
        toast.success(data || "Hall Ticket theme added successfully!", {
          autoClose: 1000,
        });
        setSelectedHallTheme(themeId);

      } else {
        toast.error(`Error: ${data || "Something went wrong"}`, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      toast.error(`Request failed: ${error.message}`, { autoClose: 2000 });
    } finally {
      setHallThemeLoading(false);
    }
  };

  // ================== FETCH SAVED THEME ==================
  useEffect(() => {
    const fetchSavedHallTheme = async () => {
      try {
        const res = await fetch(`${baseUrl}/api/principal/getTheme/${pId}`);
        const data = await res.json();

        if (data.hallTicketTheme) {
          setSelectedHallTheme(data.hallTicketTheme);

        }

      } catch (error) {
        console.error("Error fetching saved Hall Ticket theme:", error);
      }
    };

    fetchSavedHallTheme();
  }, [pId, baseUrl]);


  // ================== OPEN PREVIEW ==================
  const handleHallPreview = (themeId) => {
    setPreviewHallTheme(themeId);
    setOpenHallPreview(true);
  };

  // ------------------ Dummy Theme 1 ------------------

  const DummyHallTicket = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%", // fills dialog content height
        overflow: "hidden", // prevents scrolling
      }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/assets/Hallticket1.jpg`}
        alt="Hallticket Card Preview"
        style={{
          width: "110%",
          maxWidth: "900px",
          objectFit: "contain", // keep aspect ratio
        }}
      />
    </div>
  );

  const DummyHallTicket2 = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%", // fills dialog content height
        overflow: "hidden", // prevents scrolling
      }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/assets/Hallticket2.jpg`}
        alt="Hallticket Card Preview"
        style={{
          width: "110%",
          maxWidth: "900px",
          objectFit: "contain", // keep aspect ratio
        }}
      />
    </div>
  );

  // ------------------ Dummy Theme 3 ------------------

  const DummyHallTicket3 = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%", // fills dialog content height
        overflow: "hidden", // prevents scrolling
      }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/assets/Hallticket3.jpg`}
        alt="Hallticket Card Preview"
        style={{
          width: "110%",
          maxWidth: "900px",
          objectFit: "contain", // keep aspect ratio
        }}
      />
    </div>
  );


  // ================== SAVE BONAFIDE THEME TO API ==================
  const handleSaveBonafideTheme = async (themeId) => {
    if (!themeId) return;
    setBonafideThemeLoading(true);

    try {
      const response = await fetch(
        `${baseUrl}/api/principal/saveTheme/${pId}?bonafiedTheme=${themeId}`,
        {
          method: "POST",
        }
      );

      const data = await response.text();

      if (response.ok) {
        toast.success(data || "Bonafide theme added successfully!", {
          autoClose: 1000,
        });
        setSelectedBonafideTheme(themeId);
      } else {
        toast.error(`Error: ${data || "Something went wrong"}`, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      toast.error(`Request failed: ${error.message}`, { autoClose: 2000 });
    } finally {
      setBonafideThemeLoading(false);
    }
  };


  // ================== FETCH SAVED BONAFIDE THEME ==================
  useEffect(() => {
    const fetchSavedBonafideTheme = async () => {
      try {
        const res = await fetch(`${baseUrl}/api/principal/getTheme/${pId}`);
        const data = await res.json();

        if (data.bonafiedTheme) {
          setSelectedBonafideTheme(data.bonafiedTheme);
        }
      } catch (error) {
        console.error("Error fetching saved Bonafide theme:", error);
      }
    };

    fetchSavedBonafideTheme();
  }, [pId, baseUrl]);

  // ================== OPEN BONAFIDE PREVIEW ==================
  const handleBonafidePreview = (themeId) => {
    setPreviewBonafideTheme(themeId);
    setOpenBonafidePreview(true);
  };


  // ------------------ Dummy Theme 1 ------------------
  const DummyBonafide1 = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/assets/Bonafide2.jpeg`}
        alt="Bonafide Preview"
        style={{
          width: "95%",
          maxWidth: "900px",
          objectFit: "contain",
        }}
      />
    </div>
  );

  // ------------------ Dummy Theme 2 ------------------
  const DummyBonafide2 = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/assets/Bonafide3.jpeg`}
        alt="Bonafide Preview"
        style={{
          width: "100%",
          maxWidth: "900px",
          objectFit: "contain",
        }}
      />
    </div>
  );

  // ------------------ Dummy Theme 3 ------------------
  const DummyBonafide4 = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/assets/Bonafide4.jpeg`}
        alt="Bonafide Preview"
        style={{
          width: "100%",
          maxWidth: "900px",
          objectFit: "contain",
        }}
      />
    </div>
  );



  // ================== PROGRESS CARD STATE ==================
  // const [progressTheme, setProgressTheme] = useState("ProgressCard");
  const [progressThemeLoading, setProgressThemeLoading] = useState(false);
  const [progressTheme, setProgressTheme] = useState(""); // radio selection
  const [previewTheme, setPreviewTheme] = useState(null); // only for preview
  const [openProgressPreview, setOpenProgressPreview] = useState(false);


  // ================== SAVE TO API ==================
  const saveProgressTheme = async (themeId) => {
    if (!themeId) return;
    setProgressThemeLoading(true);

    try {
      const response = await fetch(
        `${baseUrl}/api/principal/saveTheme/${pId}?reportCardTheme=${themeId}`,
        {
          method: "POST",
        }
      );

      const data = await response.text(); // backend returns plain text

      if (response.ok) {
        toast.success(data || "Progress Card theme added successfully!", {
          autoClose: 1000,
        });
        setProgressTheme(themeId);
      } else {
        toast.error(`Error: ${data || "Something went wrong"}`, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      toast.error(`Request failed: ${error.message}`, { autoClose: 2000 });
    } finally {
      setProgressThemeLoading(false);
    }
  };


  // ================== FETCH SAVED THEME ==================
  useEffect(() => {
    const fetchSavedProgressTheme = async () => {
      try {
        const res = await fetch(`${baseUrl}/api/principal/getTheme/${pId}`);
        const data = await res.json();

        if (data.reportCardTheme) {
          setProgressTheme(data.reportCardTheme);
        }
      } catch (error) {
        console.error("Error fetching saved Progress Card theme:", error);
      }
    };

    fetchSavedProgressTheme();
  }, [pId, baseUrl]);


  // ================== OPEN PREVIEW ==================
  const handleProgressPreview = (themeId) => {
    setPreviewTheme(themeId);
    setOpenProgressPreview(true);
  };


  const DummyProgressCard = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%", // fills dialog content height
        overflow: "hidden", // prevents scrolling
      }}
    >
      {/* <h3>Progress Card Theme 1 Preview</h3> */}

      <img
        src={`${process.env.PUBLIC_URL}/assets/ReportCard1.jpeg`}
        alt="Progress Card Preview"
        // style={{ width: "100%", maxWidth: "400px", marginTop: "5px" }}
        style={{
          width: "110%",
          maxWidth: "900px",
          objectFit: "contain", // keep aspect ratio
        }}
      />
    </div>


  );

  const DummyProgressCard2 = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%", // fills dialog content height
        overflow: "hidden", // prevents scrolling
      }}
    >
      {/* <h3>Progress Card Theme 1 Preview</h3> */}

      <img
        src={`${process.env.PUBLIC_URL}/assets/ReportCard2.jpeg`}
        alt="Progress Card Preview"
        // style={{ width: "100%", maxWidth: "400px", marginTop: "5px" }}
        style={{
          width: "110%",
          maxWidth: "900px",
          objectFit: "contain", // keep aspect ratio
        }}
      />
    </div>
  );







  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box display="flex">
          {/* Sidebar */}
          <Box sx={{ width: 200, bgcolor: "#f9f9f9", borderRight: "1px solid #eee", p: 2 }}>
            <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
              Settings
            </Typography>
            <List>
              {menuItems.map((item) => (
                <ListItem
                  key={item}
                  button
                  selected={selectedMenu === item}
                  onClick={() => setSelectedMenu(item)}
                  sx={{
                    borderRadius: 1,
                    "&.Mui-selected": {
                      backgroundColor: "#e0e0ff",
                      fontWeight: "bold",
                      borderLeft: "4px solid #3f51b5",
                    },
                  }}
                >
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{ fontWeight: "bold" }}
                  />
                </ListItem>
              ))}
            </List>
          </Box>

          {/* Content Area */}
          <Box sx={{ flex: 1, p: 4 }}>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold" }}>
              {selectedMenu}
            </Typography>
            <Divider sx={{ mb: 3 }} />


            {selectedMenu === "Class Registration" ? (
              <Box>

                {/* --- Form Card --- */}
                <Paper elevation={1} sx={{ p: 3, borderRadius: 2, mb: 4 }}>
                  <Typography variant="h5" sx={{ paddingBottom: "10px", fontWeight: 'bold' }}>
                    Register Class
                  </Typography>
                  {/* <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap"> */}

                  <Grid container spacing={1} >
                    {/* Class Dropdown */}
                    <Grid item xs={12} sm={6} md={3}>

                      <FormControl fullWidth >
                        <InputLabel >Select Class</InputLabel>
                        <Select
                          value={selectedClass}
                          onChange={(e) => setSelectedClass(e.target.value)}
                          input={<OutlinedInput label="Select Class" />}
                          renderValue={(selected) =>
                            selected ? (
                              <span style={{ color: "#000" }}>{selected}</span>
                            ) : (
                              <span style={{ color: "#888" }}>Select Class</span>
                            )
                          }
                          MenuProps={{ PaperProps: { style: { width: '200px' } } }}
                        >
                          <MenuItem disabled value="">
                            Select Class
                          </MenuItem>
                          {classOptions.map((cls) => (
                            <MenuItem key={cls} value={cls}>
                              {cls}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>



                    </Grid>


                    <Grid item xs={12} sm={6} md={3}>
                      {/* Section Dropdown */}
                      <FormControl fullWidth>
                        <InputLabel >Select Section</InputLabel>
                        <Select
                          multiple

                          value={selectedSections}
                          input={<OutlinedInput label="Select Section" />}

                          onChange={(e) => setSelectedSections(e.target.value)}
                          renderValue={(selected) =>
                            selected.length ? selected.join(", ") : "Select Sections"
                          }
                          MenuProps={{ PaperProps: { style: { width: '200px' } } }}
                        >
                          {sectionOptions.map((sec) => (
                            <MenuItem key={sec} value={sec}>
                              <Checkbox checked={selectedSections.includes(sec)} />
                              {sec}
                            </MenuItem>
                          ))}

                          {/* "+" Button to Add Section */}
                          <MenuItem
                            onClick={(e) => {
                              e.stopPropagation();
                              const lastSection = sectionOptions[sectionOptions.length - 1];
                              const lastChar = lastSection.slice(-1); // e.g., "A"
                              const nextChar = String.fromCharCode(lastChar.charCodeAt(0) + 1);
                              const nextSection = `Section-${nextChar}`;

                              if (!sectionOptions.includes(nextSection)) {
                                setSectionOptions([...sectionOptions, nextSection]);
                              }
                            }}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              color: "#1976d2",
                              fontWeight: "bold",
                              borderTop: "1px solid #eee",
                            }}
                          >
                            + Add Section
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>

                      {/* Subject Dropdown */}

                      <FormControl fullWidth>
                        <InputLabel>Select Subjects</InputLabel>
                        <Select
                          multiple
                          value={selectedSubjects}
                          input={<OutlinedInput label="Select Subjects" />}
                          renderValue={(selected) => selected.join(", ")}
                          MenuProps={{ PaperProps: { style: { maxHeight: 300, width: '200px' } } }}
                        >
                          <MenuItem disableRipple disableTouchRipple>
                            <Box display="flex" gap={1} width="100%">
                              <TextField
                                placeholder="Add Subject"
                                value={customSubject}
                                onChange={(e) => setCustomSubject(e.target.value)}
                                size="small"
                                fullWidth
                                onKeyDown={(e) => {
                                  e.stopPropagation();
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleAddSubject();
                                  }
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={handleAddSubject}
                                sx={{
                                  color: "gray", // default color
                                  "&:hover": {
                                    color: "black", // hover color
                                    backgroundColor: "transparent", // prevent background
                                  },
                                  "&:active": {
                                    color: "black", // optional: active/click color
                                  },
                                }}
                              >
                                <AddIcon fontSize="medium" />
                              </IconButton>

                            </Box>
                          </MenuItem>

                          <MenuItem onClick={handleSelectAll}>
                            <Checkbox
                              checked={selectedSubjects.length === subjectOptions.length}
                              indeterminate={
                                selectedSubjects.length > 0 &&
                                selectedSubjects.length < subjectOptions.length
                              }
                            />
                            <Typography>Select All</Typography>
                          </MenuItem>

                          {subjectOptions.map((subj) => (
                            <MenuItem
                              key={subj}
                              onClick={() => handleToggle(subj)}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                "&:hover .remove-icon": { visibility: "visible" },
                              }}
                            >
                              <Box display="flex" alignItems="center">
                                <Checkbox checked={selectedSubjects.includes(subj)} />
                                <Typography>{subj}</Typography>
                              </Box>
                              <IconButton
                                className="remove-icon"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveSubject(subj);
                                }}
                                size="small"
                                sx={{ visibility: "hidden" }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    {/* Exam Type Dropdown */}

                    <Grid item xs={12} sm={6} md={3}>
                      <FormControl fullWidth >
                        <InputLabel id="exam-type-label">Select Exam Type</InputLabel>
                        <Select
                          labelId="exam-type-label"
                          multiple
                          value={selectedExamType}
                          input={<OutlinedInput label="Select Exam Type" />}
                          renderValue={(selected) =>
                            selected.length > 0 ? selected.join(", ") : "Select Exam Type"
                          }
                          MenuProps={{ PaperProps: { style: { width: '200px' } } }}
                        >
                          {/* Add new exam type */}
                          <MenuItem disableRipple disableTouchRipple>
                            <Box display="flex" gap={1} width="100%">
                              <TextField
                                placeholder="Add Exam Type"
                                value={customExamType}
                                onChange={(e) => setCustomExamType(e.target.value)}
                                size="small"
                                fullWidth
                                onKeyDown={(e) => {
                                  e.stopPropagation();
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleAddExamType();
                                  }
                                }}
                              />
                              {/* <IconButton size="small" onClick={handleAddExamType}>
              <AddIcon fontSize="medium" />
            </IconButton> */}
                              <IconButton
                                size="small"
                                onClick={handleAddExamType}
                                sx={{
                                  color: "gray", // default color
                                  "&:hover": {
                                    color: "black", // hover color
                                    backgroundColor: "transparent", // prevent background
                                  },
                                  "&:active": {
                                    color: "black", // optional: active/click color
                                  },
                                }}
                              >
                                <AddIcon fontSize="medium" />
                              </IconButton>
                            </Box>
                          </MenuItem>

                          {/* Select All option */}
                          <MenuItem onClick={handleExamTypeSelectAll}>
                            <Checkbox
                              checked={selectedExamType.length === examTypes.length}
                              indeterminate={
                                selectedExamType.length > 0 &&
                                selectedExamType.length < examTypes.length
                              }
                            />
                            <Typography>Select All</Typography>
                          </MenuItem>

                          {/* Exam type options with delete icon */}
                          {examTypes.map((type) => (
                            <MenuItem
                              key={type}
                              onClick={() => handleExamTypeToggle(type)}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                "&:hover .remove-icon": { visibility: "visible" },
                              }}
                            >
                              <Box display="flex" alignItems="center">
                                <Checkbox checked={selectedExamType.includes(type)} />
                                <Typography>{type}</Typography>
                              </Box>
                              <IconButton
                                className="remove-icon"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveType(type);
                                }}
                                size="small"
                                sx={{ visibility: "hidden" }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                  </Grid>

                  {/* Submit Button */}
                  <Grid item xs={12} sm={6} md={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: '10px' }}>
                    <Button
                      fullWidth
                      variant="contained"
                      disabled={loading}
                      sx={{
                        width: 95,
                        height: 48,
                        backgroundColor: "#3C3972",
                        "&:hover": { backgroundColor: "#2e2b59" },
                      }}
                      onClick={handleRegisterClass}
                    >
                      {loading ? (
                        <Box display="flex" alignItems="center" gap={1}>
                          <CircularProgress size={20} sx={{ color: "white" }} />
                          Loading...
                        </Box>
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </Grid>

                  {/* </Stack> */}
                </Paper>


                {/* --- Table Card --- */}
                <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
                  <Typography variant="h5" sx={{ paddingBottom: "10px", fontWeight: 'bold' }}>
                    Registered Classes
                  </Typography>

                  <GlobalStyles
                    styles={{
                      '.custom-sidebar-scrollbar': {
                        scrollbarWidth: 'thin',
                        scrollbarColor: 'grey #e0e0e0',
                      },
                      '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                        width: '6px',
                      },
                      '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                      },
                      '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                        backgroundColor: 'grey',
                        borderRadius: '10px',
                      },
                      '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: '#555',
                      },
                    }}
                  />

                  <TableContainer
                    component={Paper}
                    sx={{
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      maxHeight: "350px",
                      overflow: "auto",
                      mt: 2,
                    }}
                    className="custom-sidebar-scrollbar"
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={headerStyle}>Class</TableCell>
                          <TableCell sx={headerStyle}>Sections</TableCell>
                          <TableCell sx={headerStyle}>Subjects</TableCell>
                          <TableCell sx={headerStyle}>ExamType</TableCell>
                          <TableCell sx={headerStyle}>Action</TableCell>
                        </TableRow>
                      </TableHead>

                      {tableLoading ? (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={9} style={{ textAlign: "center", padding: "20px" }}>
                              <Box display="flex" flexDirection="column" alignItems="center">
                                <CircularProgress />
                                <Typography variant="body2" sx={{ mt: 1 }}>Loading Data...</Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : tableData.length === 0 ? (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={9} sx={{ textAlign: "center", padding: "20px" }}>
                              No data found
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : (
                        <TableBody>
                          {tableData.map((row, index) => (
                            <TableRow key={index} sx={{ backgroundColor: "white", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                {row.classRegistration}
                              </TableCell>
                              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                {row.classSectionLimit}
                              </TableCell>
                              <TableCell sx={{ width: 230, maxWidth: 230, whiteSpace: "normal", wordWrap: "break-word", borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                {row.allSubject}
                              </TableCell>
                              <TableCell sx={{ width: 230, maxWidth: 230, whiteSpace: "normal", wordWrap: "break-word", borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                {row.examTypes}
                              </TableCell>
                              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                                  <Button
                                    variant="contained"
                                    sx={{
                                      backgroundColor: "#1976d2",
                                      color: "white",
                                      minWidth: "60px",
                                      fontSize: "0.75rem",
                                      padding: "3px 8px",
                                      "&:hover": { backgroundColor: "#1565c0" },
                                    }}
                                    size="small"
                                    onClick={() => handleEditRow(row)}
                                  >
                                    Edit
                                  </Button>
                                  {/*<Button
                                    variant="contained"
                                    sx={{
                                      backgroundColor: "#a82814",
                                      color: "#fff",
                                      minWidth: "60px",
                                      fontSize: "0.75rem",
                                      padding: "3px 8px",
                                      "&:hover": { backgroundColor: "#7a1b0e" },
                                    }}
                                    size="small"
                                    onClick={() => handleDeleteRow(row)}
                                  >
                                    Delete
                                  </Button>8*/}
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>
                </Paper>

                {/* --- Edit Modal --- */}
                {isEditModalOpen && selectedRow && (
                  <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 500,
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: "1% 2% 1% 2%",
                        borderRadius: 2,
                      }}
                    >
                      <Typography variant="h4" sx={{ fontWeight: 'bold', paddingBottom: '10px' }}>Edit Class Registration</Typography>

                      <Stack spacing={2}>
                        {/* Class */}
                        <FormControl fullWidth>
                          <InputLabel>Class</InputLabel>
                          <Select
                            value={editClass}
                            label="Class"
                            onChange={(e) => setEditClass(e.target.value)}
                            disabled
                            sx={{
                              backgroundColor: "#f0f0f0",
                              color: "#6c757d",
                              fontWeight: "bold",
                            }}
                          >
                            {classOptions.map((cls) => (
                              <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        {/* Sections */}


                        <TextField
                          label="Sections"
                          value={rowSectionsInput}
                          onChange={handleInputChange(setRowSectionsInput)}
                          onBlur={handleBlur}
                          fullWidth
                          margin="normal"
                          size="medium"

                        />

                        <TextField
                          label="Subjects"
                          value={editSubjectsInput}
                          onChange={handleInputChange(setEditSubjectsInput)}
                          onBlur={handleBlur}
                          fullWidth
                          margin="normal"
                          size="medium"
                        />

                        <TextField
                          label="Exam Types"
                          value={editExamTypeInput}
                          onChange={handleInputChange(setEditExamTypeInput)}
                          onBlur={handleBlur}
                          fullWidth
                          margin="normal"
                          size="medium"
                        />

                        {/* Modal Actions */}
                        <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                          <Button variant="outlined" onClick={() => setIsEditModalOpen(false)}>Cancel</Button>

                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "#3C3972", '&:hover': {
                                backgroundColor: "#3C3972", // Change this to your hover color
                              }, color: "white", minWidth: 100
                            }}
                            onClick={() => {
                              const updatedRow = {
                                ...selectedRow,
                                classRegistration: editClass,
                                classSectionLimit: rowSections.join(", "),
                                allSubject: editSubjects.join(", "),
                                examTypes: editExamType,
                              };
                              handleUpdateRow(updatedRow);
                            }}
                            disabled={isUpdating} // disable button while loading
                          >
                            {isUpdating ? (
                              <CircularProgress size={20} sx={{ color: "white" }} />
                            ) : (
                              "Save"
                            )}
                          </Button>
                        </Box>
                      </Stack>
                    </Box>
                  </Modal>
                )}

              </Box>


            ) : selectedMenu === "TimeTable Schedule" ? (
              <Box sx={{ overflowX: 'auto', width: '100%' }}>
                {/* --- Timetable Scheduling Form --- */}
                <Paper elevation={3} sx={{ p: "1% 2% 2% 2%", borderRadius: 2, mb: 4 }}>
                  <Typography variant="h5" sx={{ paddingBottom: "10px", fontWeight: 'bold' }}>
                    TimeTable Schedule
                  </Typography>
                  {/* <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap"> */}
                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    sx={{ minWidth: 'max-content', flexWrap: 'nowrap' }}
                  >
                    {/* <TextField
                      label="Period Number"
                      type="number"
                      value={periodNumber}
                      onChange={(e) => setPeriodNumber(e.target.value)}
                      sx={{ width: 150 }}
                      size="small"
                    /> */}
                    <TextField
                      label="Period Number"
                      type="text" // use text to control custom input filtering
                      value={periodNumber}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Allow only digits (no letters, no symbols)
                        if (/^\d*$/.test(value)) {
                          setPeriodNumber(value);
                        }
                      }}
                      sx={{ width: 150 }}
                      size="small"
                    />

                    <TextField
                      label="Start Time"
                      type="time"
                      value={startTime}
                      onChange={(e) => setStartTime(e.target.value)}
                      sx={{ width: 150 }}
                      size="small"
                      InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                      label="End Time"
                      type="time"
                      value={endTime}
                      onChange={(e) => setEndTime(e.target.value)}
                      sx={{ width: 150 }}
                      size="small"
                      InputLabelProps={{ shrink: true }}
                    />

                    <FormControl sx={{ width: 200 }} size="small">
                      <InputLabel>Select Type</InputLabel>
                      <Select
                        open={open}
                        onOpen={() => setOpen(true)}
                        onClose={() => setOpen(false)}
                        value={selectedType}
                        label="Select Type"
                        onChange={(e) => {
                          setSelectedType(e.target.value);
                          setOpen(false);
                        }}
                        renderValue={(selected) => selected || "Select Type"}
                        MenuProps={{
                          PaperProps: { style: { width: "200px" } },
                        }}
                      >


                        {typeOptions.map((opt) => (
                          <MenuItem
                            key={opt}
                            value={opt}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              "&:hover .remove-icon": { visibility: "visible" },
                            }}
                          >
                            <Typography>{opt}</Typography>
                            {/* <IconButton
                              className="remove-icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveScheduledType(opt);
                              }}
                              size="small"
                              sx={{ visibility: "hidden" }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton> */}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    {/* </Stack> */}
                    {/* <div sx={{display: "flex", justifyContent: "flex-end", alignItems: "center" ,marginTop:'10px'}}> */}
                    <Button
                      variant="contained"
                      sx={{
                        height: 36,
                        backgroundColor: "#3C3972",
                        "&:hover": { backgroundColor: "#2e2b59" },
                      }}
                      onClick={handleTimetableSubmit}
                    >
                      {loading ? (
                        <>
                          <CircularProgress size={20} sx={{ color: "white", marginRight: 1 }} />
                          Submit
                        </>
                      ) : (
                        "Submit"
                      )}
                    </Button>
                    {/* </div> */}


                  </Stack>
                </Paper>

                {/* --- Timetable Table --- */}
                <Paper elevation={3} sx={{ p: "1% 2% 2% 2%", borderRadius: 2 }}>
                  <Typography variant="h5" sx={{ paddingBottom: "10px", fontWeight: 'bold' }}>
                    Scheduled Periods
                  </Typography>

                  <GlobalStyles
                    styles={{
                      ".custom-sidebar-scrollbar": {
                        scrollbarWidth: "thin",
                        scrollbarColor: "grey #e0e0e0",
                      },
                      ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                        width: "6px",
                      },
                      ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                      },
                      ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                        backgroundColor: "grey",
                        borderRadius: "10px",
                      },
                      ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#555",
                      },
                    }}
                  />

                  <TableContainer
                    component={Paper}
                    className="custom-sidebar-scrollbar"
                    sx={{
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      maxHeight: "350px",
                      overflow: "auto",
                      mt: 2,
                    }}
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={headerStyle}>Period No</TableCell>
                          <TableCell sx={headerStyle}>Start Time</TableCell>
                          <TableCell sx={headerStyle}>End Time</TableCell>
                          <TableCell sx={headerStyle}>Type</TableCell>
                          <TableCell sx={headerStyle}>Action</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {scheduledPeriodsLoading ? (
                          <TableRow>
                            <TableCell colSpan={5} style={{ textAlign: "center", padding: "20px" }}>
                              <Box display="flex" flexDirection="column" alignItems="center">
                                <CircularProgress />
                                <Typography variant="body2" sx={{ mt: 1 }}>
                                  Loading Data...
                                </Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ) : timetableData.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={5} sx={{ textAlign: "center" }}>
                              No data found
                            </TableCell>
                          </TableRow>
                        ) : (
                          timetableData.map((row, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                backgroundColor: "white",
                                "&:hover": { backgroundColor: "#f5f5f5" },
                              }}
                            >
                              <TableCell sx={cellStyle}>{row.periodNumber || "Break"}</TableCell>
                              <TableCell sx={cellStyle}>{row.startTime}</TableCell>
                              <TableCell sx={cellStyle}>{row.endTime}</TableCell>
                              <TableCell sx={cellStyle}>{row.type}</TableCell>
                              <TableCell sx={cellStyle}>
                                <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                                  {/* <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                      backgroundColor: "#1976d2",
                                      color: "white",
                                      fontSize: "0.75rem",
                                      padding: "3px 8px",
                                      "&:hover": { backgroundColor: "#1565c0" },
                                    }}
                                    onClick={() => handleEditTimetableRow(row)}
                                  >
                                    Edit
                                  </Button> */}
                                  <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                      backgroundColor: "#a82814",
                                      color: "white",
                                      fontSize: "0.75rem",
                                      padding: "3px 8px",
                                      "&:hover": { backgroundColor: "#7a1b0e" },
                                    }}
                                    onClick={() => {
                                      console.log("Deleting row:", row);
                                      handleDeleteScheduledPeriod(row)
                                    }}
                                  >
                                    Delete
                                  </Button>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>

                {/* --- Edit Modal --- */}
                {isTimetableEditModalOpen && selectedRow && (
                  <Modal open={isTimetableEditModalOpen} onClose={() => setIsTimetableEditModalOpen(false)}>
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 400,
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 2,
                      }}
                    >
                      <Typography variant="h6" gutterBottom>
                        Edit Scheduled Period
                      </Typography>

                      <Stack spacing={2}>
                        {/* Period Number */}
                        <TextField
                          fullWidth
                          label="Period Number"
                          type="number"
                          value={editPeriodNumber}
                          onChange={(e) => setEditPeriodNumber(e.target.value)}
                        />

                        {/* Start Time */}
                        <TextField
                          fullWidth
                          label="Start Time"
                          type="time"
                          InputLabelProps={{ shrink: true }}
                          value={editStartTime}
                          onChange={(e) => setEditStartTime(e.target.value)}
                        />

                        {/* End Time */}
                        <TextField
                          fullWidth
                          label="End Time"
                          type="time"
                          InputLabelProps={{ shrink: true }}
                          value={editEndTime}
                          onChange={(e) => setEditEndTime(e.target.value)}
                        />

                        {/* Type */}
                        <FormControl fullWidth>
                          <InputLabel>Type</InputLabel>
                          <Select
                            value={editType}
                            label="Type"
                            onChange={(e) => setEditType(e.target.value)}
                          >
                            {["Lecture", "Break", "Lab", "Activity"].map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        {/* Modal Actions */}
                        <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                          <Button variant="outlined" onClick={() => setIsTimetableEditModalOpen(false)}>
                            Cancel
                          </Button>
                          <Button
                            variant="contained"
                            sx={{ backgroundColor: "#3C3972", color: "white" }}
                            onClick={() => {
                              const updatedRow = {
                                ...selectedRow,
                                periodNumber: editPeriodNumber,
                                startTime: editStartTime,
                                endTime: editEndTime,
                                type: editType,
                              };
                              handleUpdateTimetableRow(updatedRow);
                              setIsTimetableEditModalOpen(false);
                            }}
                          >
                            Save
                          </Button>
                        </Box>
                      </Stack>
                    </Box>
                  </Modal>
                )}



              </Box>

            ) : selectedMenu === "Receipt Prefix" ? (

              <Card
                sx={{
                  maxWidth: 800,          // a bit wider for the whole row
                  mx: "auto",
                  mt: 4,
                  p: 3,
                  borderRadius: 4,
                  boxShadow: 5,
                  backgroundColor: "#f9f9f9",
                }}
              >
                <CardContent>
                  <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Configure Receipt Prefix and Sequence Number
                  </Typography>

                  {/* Preview panel – unchanged */}
                  <Paper
                    elevation={3}
                    sx={{
                      my: 2,
                      p: 2,
                      backgroundColor: "#e0f7fa",
                      textAlign: "center",
                      fontSize: "1.2rem",
                      fontWeight: 600,
                      color: "#00796b",
                    }}
                  >
                    Preview: {receiptPrefix || "____"}-{startSequence || "____"}
                  </Paper>

                  {/* Form row */}
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={2}
                    alignItems="center"
                  >

                    <TextField
                      label="Receipt Type"
                      select
                      value={rolePayment}
                      onChange={(e) => setfeeType(e.target.value)}
                      sx={{ flex: 1, minWidth: 150 }}
                      required
                    >
                      <MenuItem value="admission_fee">Admission_Fee Receipt</MenuItem>
                      <MenuItem value="tution_fee">Tution_Fee Receipt</MenuItem>
                      {(feature === "CORE" || feature === "ULTRA") && (
                        <MenuItem value="bus_fee">Bus_Fee Receipt</MenuItem>
                      )}
                      <MenuItem value="exam_fee">Exam_Fee Receipt</MenuItem>
                      <MenuItem value="hostel_fee">Hostel_Fee Receipt</MenuItem>
                      {/* <MenuItem value="other_fee">Other_Fee Receipt</MenuItem> */}
                    </TextField>

                    {/* <TextField
                      label="Prefix"
                      value={receiptPrefix}
                      onChange={(e) => setPrefix(e.target.value)}
                      sx={{ flex: 1 }}
                      required
                    /> */}
                    <TextField
                      label="Prefix"
                      value={receiptPrefix}
                      onChange={(e) => {
                        const val = e.target.value.toUpperCase();
                        if (/^[A-Za-z]{0,5}$/.test(val)) {
                          setPrefix(val);
                        }
                      }}
                      required
                      inputProps={{ maxLength: 5 }}
                      error={receiptPrefix.length > 0 && receiptPrefix.length < 3}

                      sx={{ flex: 1 }}
                    />


                    <TextField
                      label="Sequence Number"
                      type="number"
                      value={startSequence}
                      onChange={(e) => setSequence(e.target.value)}
                      sx={{ flex: 1 }}
                      required
                    />


                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                      disabled={prefixloading}
                      sx={{
                        minWidth: 120, minHeight: 45, backgroundColor: "#3C3972", '&:hover': {
                          backgroundColor: "#3C3972", // same as normal
                        }
                      }}
                    >
                      {prefixloading ? (
                        <CircularProgress size={24} sx={{ color: "#fff" }} />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </Stack>
                </CardContent>
              </Card>




            ) : selectedMenu === "Location & Radius" ? (
              <Card
                sx={{
                  maxWidth: 800,
                  mx: "auto",
                  mt: 4,
                  p: 3,
                  borderRadius: 4,
                  boxShadow: 5,
                  backgroundColor: "#f9f9f9",
                }}
              >
                <CardContent>
                  <Typography variant="h6" fontWeight="bold" mb={1}>
                    Set Latitude, Longitude & Radius
                  </Typography>

                  {/* 🔔 Instructional Note */}
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#555",
                      // fontStyle: "",
                      backgroundColor: "#fffde7",
                      border: "1px solid #f0c36d",
                      borderRadius: 1,
                      p: 1.5,
                      mb: 3,
                      fontSize: 14
                    }}
                  >
                    <strong>Note:</strong> Please enter accurate latitude and longitude values. Radius should be a number in meters (e.g.50, 100, 150, etc).
                  </Typography>

                  {/* Row of 3 input fields */}
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={2}
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <TextField
                      label="Latitude"
                      // type="number"
                      value={latitude}
                      onChange={(e) => setLatitude(e.target.value)}
                      required
                      fullWidth
                    />

                    <TextField
                      label="Longitude"
                      // type="number"
                      value={longitude}
                      onChange={(e) => setLongitude(e.target.value)}
                      required
                      fullWidth
                    />

                    <TextField
                      label="Radius (meters)"
                      // type="number"
                      value={radius}
                      onChange={(e) => setRadius(e.target.value)}
                      required
                      fullWidth
                    />
                    {/* Centered Submit Button */}
                    <Box mt={4} display="flex" justifyContent="center">
                      <Button
                        variant="contained"
                        disabled={locationLoading}
                        onClick={handleLocationSave}
                        sx={{
                          backgroundColor: "#3C3972",
                          color: "#fff",
                          px: 4,
                          '&:hover': {
                            backgroundColor: "#3C3972",
                          },
                          minHeight: 50,
                        }}
                      >
                        {locationLoading ? (
                          <CircularProgress size={23} sx={{ color: "#fff" }} />
                        ) : (
                          "Submit"
                        )}
                      </Button>
                    </Box>
                  </Stack>



                  {radius && (
                    <Box mt={3} textAlign="center">
                      <Typography variant="subtitle1" mb={1} sx={{ fontWeight: 'bold' }}>
                        {radius}m Radius Visual
                      </Typography>

                      <Box
                        sx={{
                          position: "relative",
                          display: "inline-block",
                          width: 250,
                          height: 250,
                        }}
                      >
                        <Box
                          component="img"
                          src="/assets/LocationImg.png" // 👈 Save the uploaded image to public/images with this name
                          alt="Radius circle"
                          sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            borderRadius: "50%",
                            boxShadow: 2,
                          }}
                        />
                        <Typography
                          variant="h6"
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            fontWeight: "bold",
                            color: "#3C3972",
                            backgroundColor: "rgba(255,255,255,0.7)",
                            px: 1,
                            borderRadius: 1,
                          }}
                        >
                          {radius}m
                        </Typography>
                      </Box>
                    </Box>
                  )}


                </CardContent>
              </Card>



            ) : selectedMenu === "Additional Fee" ? (
              <Box>

                {/* --- Form Card --- */}
                <Paper elevation={1} sx={{ p: 3, borderRadius: 2, mb: 4 }}>
                  <Typography variant="h5" sx={{ paddingBottom: "10px", fontWeight: "bold" }}>
                    Add Items
                  </Typography>

                  <Grid container spacing={2}>

                    {/* Class Selector */}
                    <Grid item xs={12} sm={6} md={3}>
                      <FormControl fullWidth>
                        <InputLabel id="class-select-label">Select Class</InputLabel>
                        <Select
                          value={sscSelectedClass}
                          label="Select Class"
                          onChange={(e) => setSscSelectedClass(e.target.value)}
                        >
                          {sscClassOptions.length > 0 ? (
                            sscClassOptions.map((cls) => (
                              <MenuItem key={cls} value={cls}>
                                {cls}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>No classes available</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </Grid>




                    <Grid item xs={12} sm={6} md={3}>
                      <TextField
                        label="Item Name"
                        value={itemName}
                        onChange={(e) => setItemName(e.target.value)}
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                      <TextField
                        label="Amount"
                        value={amount}
                        onKeyDown={(e) => {
                          // Allow only digits and control keys like Backspace, Delete, Arrow keys
                          const allowedKeys = [
                            "Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"
                          ];
                          if (
                            !/^\d$/.test(e.key) && // if not a digit
                            !allowedKeys.includes(e.key)
                          ) {
                            e.preventDefault(); // Block the key press
                          }
                        }}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (/^\d*$/.test(val)) {
                            setAmount(val);
                          }
                        }}
                        fullWidth
                        type="text"
                        placeholder="Enter Amount"
                        inputProps={{ min: 1 }}
                      />

                    </Grid>

                    <Grid item xs={12} sm={6} md={3} sx={{ display: "flex", alignItems: "flex-end" }}>
                      <Button
                        fullWidth
                        variant="contained"
                        disabled={itemsloading}
                        sx={{
                          width: 95,
                          height: 50,
                          backgroundColor: "#3C3972",
                          "&:hover": { backgroundColor: "#2e2b59" },
                        }}
                        onClick={handleSubmitItem}
                      >
                        {itemsloading ? (
                          <Box display="flex" alignItems="center" gap={1}>
                            <CircularProgress size={20} sx={{ color: "white" }} />
                            Loading...
                          </Box>
                        ) : (
                          "Submit"
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </Paper>


                {/* --- Table Card --- */}
                <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
                  <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                    <Grid item>
                      <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                        Added Items
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="class-select-label">Select Class</InputLabel>
                        <Select
                          value={tablesscSelectedClass}
                          label="Select Class"
                          onChange={(e) => setTableSscSelectedClass(e.target.value)}
                        >
                          {sscClassOptions.length > 0 ? (
                            sscClassOptions.map((cls) => (
                              <MenuItem key={cls} value={cls}>
                                {cls}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>No classes available</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>


                  <GlobalStyles
                    styles={{
                      '.custom-sidebar-scrollbar': {
                        scrollbarWidth: 'thin',
                        scrollbarColor: 'grey #e0e0e0',
                      },
                      '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                        width: '6px',
                      },
                      '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                      },
                      '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                        backgroundColor: 'grey',
                        borderRadius: '10px',
                      },
                      '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: '#555',
                      },
                    }}
                  />

                  <TableContainer
                    component={Paper}
                    sx={{
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      maxHeight: "350px",
                      overflow: "auto",
                      mt: 2,
                    }}
                    className="custom-sidebar-scrollbar"
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={headerStyle}>Sl No</TableCell>
                          <TableCell sx={headerStyle}>Item Name</TableCell>
                          <TableCell sx={headerStyle}>Amount</TableCell>
                          <TableCell sx={headerStyle}>Actions</TableCell>
                        </TableRow>
                      </TableHead>

                      {itemstableLoading ? (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={9} style={{ textAlign: "center", padding: "20px" }}>
                              <Box display="flex" flexDirection="column" alignItems="center">
                                <CircularProgress />
                                <Typography variant="body2" sx={{ mt: 1 }}>Loading Data...</Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : itemsTableData.length === 0 ? (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={9} sx={{ textAlign: "center", padding: "20px" }}>
                              No items found for the selected class
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : (
                        <TableBody>
                          {itemsTableData.map((row, index) => (
                            <TableRow key={index} sx={{ backgroundColor: "white", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                {index + 1}
                              </TableCell>
                              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                {row.itemNames}
                              </TableCell>
                              <TableCell sx={{ width: 230, maxWidth: 230, whiteSpace: "normal", wordWrap: "break-word", borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                ₹{row.pricePerItemAmount}
                              </TableCell>

                              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                                  <Button
                                    variant="contained"
                                    sx={{
                                      backgroundColor: "#1976d2",
                                      color: "white",
                                      minWidth: "60px",
                                      fontSize: "0.75rem",
                                      padding: "3px 8px",
                                      "&:hover": { backgroundColor: "#1565c0" },
                                    }}
                                    size="small"
                                    onClick={() => handleItemsEditRow(row)}
                                  >
                                    Edit
                                  </Button>
                                  <Button
                                    variant="contained"
                                    sx={{
                                      backgroundColor: "#a82814",
                                      color: "#fff",
                                      minWidth: "60px",
                                      fontSize: "0.75rem",
                                      padding: "3px 8px",
                                      "&:hover": { backgroundColor: "#7a1b0e" },
                                    }}
                                    size="small"
                                    onClick={() => handleItemsDeleteRow(row)}
                                  >
                                    Delete
                                  </Button>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>
                </Paper>

                {/* --- Edit Modal --- */}
                {isItemsEditModalOpen && (
                  <Modal open={isItemsEditModalOpen} onClose={() => setIsItemsEditModalOpen(false)}>
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 500,
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: "1% 2%",
                        borderRadius: 2,
                      }}
                    >
                      <Typography variant="h5" sx={{ fontWeight: 'bold', paddingBottom: '10px' }}>
                        Edit Item
                      </Typography>

                      <Stack spacing={2}>
                        <TextField
                          label="Item Name"
                          value={editItemData.itemNames}
                          onChange={(e) => setEditItemData({ ...editItemData, itemNames: e.target.value })}
                          fullWidth
                          margin="normal"
                          size="medium"
                        />


                        <TextField
                          label="Amount"
                          type="number"
                          value={editItemData.amount}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (/^\d*$/.test(val)) {
                              setEditItemData({ ...editItemData, amount: val });
                            }
                          }}
                          fullWidth
                          margin="normal"
                          size="medium"
                          inputProps={{ min: 1 }}
                        />


                        <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                          <Button variant="outlined" onClick={() => setIsItemsEditModalOpen(false)}>
                            Cancel
                          </Button>

                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "#3C3972",
                              "&:hover": { backgroundColor: "#2e2b59" },
                              color: "white",
                              minWidth: 100,
                            }}
                            onClick={handleSaveEditedItem}
                            disabled={isDialogSaveUpdating}
                          >
                            {isDialogSaveUpdating ? (
                              <CircularProgress size={20} sx={{ color: "white" }} />
                            ) : (
                              "Save"
                            )}
                          </Button>
                        </Box>
                      </Stack>
                    </Box>
                  </Modal>
                )}


              </Box>

            ) : selectedMenu === "Hall Ticket" ? (
              <Box>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  Select Hall Ticket Theme
                </Typography>

                <RadioGroup
                  value={selectedHallTheme}
                  onChange={(e) => handleSaveHallTheme(e.target.value)}
                >
                  {[
                    // { id: "HallTicketTemplate", label: "Theme 1" },
                    { id: "HallTicketTemplate2", label: "Theme 1" },
                    { id: "HallTicketTemplate3", label: "Theme 2" },
                  ].map((theme) => (
                    <Box
                      key={theme.id}
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      mb={1}
                      sx={{ border: "1px solid #ccc", borderRadius: "8px", p: 1 }}
                    >
                      <FormControlLabel
                        value={theme.id}
                        control={<Radio />}
                        label={theme.label}
                      />
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => handleHallPreview(theme.id)}
                      >
                        View
                      </Button>
                    </Box>
                  ))}
                </RadioGroup>

                {/* Preview Dialog */}
                <Dialog
                  open={openHallPreview}
                  onClose={() => setOpenHallPreview(false)}
                  PaperProps={{
                    sx: {
                      width: "700px",
                      height: "550px",
                      maxWidth: "none",
                      zIndex: 2000,
                      display: "flex",
                      flexDirection: "column",
                      overflow: "hidden",
                      justifyContent: "center",
                    },
                  }}
                >
                  <DialogTitle sx={{ pb: 1 }}>Hall Ticket Preview</DialogTitle>

                  <DialogContent
                    sx={{
                      flex: 1,
                      p: 2,
                      pt: 0,
                      overflowY: "auto",
                    }}
                  >
                    {previewHallTheme === "HallTicketTemplate" && <DummyHallTicket />}
                    {previewHallTheme === "HallTicketTemplate2" && <DummyHallTicket2 />}
                    {previewHallTheme === "HallTicketTemplate3" && <DummyHallTicket3 />}
                  </DialogContent>

                  <DialogActions sx={{ justifyContent: "flex-end", p: 1, pt: 0 }}>
                    <Button
                      variant="outlined"
                      onClick={() => setOpenHallPreview(false)}
                    >
                      Cancel
                    </Button>
                  </DialogActions>
                </Dialog>

              </Box>
            ) :
              selectedMenu === "Bonafide" ? (
                <Box>
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    Select Bonafide Theme
                  </Typography>

                  <RadioGroup
                    value={selectedBonafideTheme}
                    onChange={(e) => handleSaveBonafideTheme(e.target.value)}
                  >
                    {[
                      // { id: "Bonafide2", label: "Theme 1" },
                      { id: "Bonafide3", label: "Theme 1" },
                      { id: "Bonafide4", label: "Theme 2" },
                    ].map((theme) => (
                      <Box
                        key={theme.id}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        mb={1}
                        sx={{ border: "1px solid #ccc", borderRadius: "8px", p: 1 }}
                      >
                        <FormControlLabel
                          value={theme.id}
                          control={<Radio />}
                          label={theme.label}
                        />
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => handleBonafidePreview(theme.id)}
                        >
                          View
                        </Button>
                      </Box>
                    ))}
                  </RadioGroup>

                  {/* ✅ BONAFIDE PREVIEW DIALOG */}
                  <Dialog
                    open={openBonafidePreview}
                    onClose={() => setOpenBonafidePreview(false)}
                    PaperProps={{
                      sx: {
                        width: "700px",
                        height: "550px",
                        maxWidth: "none",
                        zIndex: 2000,
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                        justifyContent: "center",
                      },
                    }}
                  >
                    <DialogTitle sx={{ pb: 1 }}>Bonafide Preview</DialogTitle>

                    <DialogContent
                      sx={{
                        flex: 1,
                        p: 2,
                        pt: 0,
                        overflowY: "auto",
                      }}
                    >
                      {previewBonafideTheme === "Bonafide2" && <DummyBonafide1 />}
                      {previewBonafideTheme === "Bonafide3" && <DummyBonafide2 />}
                      {previewBonafideTheme === "Bonafide4" && <DummyBonafide4 />}
                    </DialogContent>

                    <DialogActions sx={{ justifyContent: "flex-end", p: 1, pt: 0 }}>
                      <Button
                        variant="outlined"
                        onClick={() => setOpenBonafidePreview(false)}
                      >
                        Cancel
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Box>
              )

                : selectedMenu === "Progress Card" ? (
                  <Box>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      Select Progress Card Theme
                    </Typography>

                    <RadioGroup
                      value={progressTheme}
                      onChange={(e) => saveProgressTheme(e.target.value)}
                    >
                      {[
                        { id: "ProgressCard", label: "Theme 1" },
                        { id: "ProgressCard2", label: "Theme 2" },
                      ].map((theme) => (
                        <Box
                          key={theme.id}
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          mb={1}
                          sx={{ border: "1px solid #ccc", borderRadius: "8px", p: 1 }}
                        >
                          <FormControlLabel
                            value={theme.id}
                            control={<Radio />}
                            label={theme.label}
                          />
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => handleProgressPreview(theme.id)}
                          >
                            View
                          </Button>
                        </Box>
                      ))}
                    </RadioGroup>

                    {/* Preview Dialog */}
                    <Dialog
                      open={openProgressPreview}
                      onClose={() => setOpenProgressPreview(false)}
                      PaperProps={{
                        sx: {
                          width: "500px",
                          height: "550px",
                          maxWidth: "none",
                          zIndex: 2000,
                          display: "flex",
                          flexDirection: "column",
                        },
                      }}
                    >
                      <DialogTitle sx={{ pb: 1 }}>Progress Card Preview</DialogTitle>

                      <DialogContent
                        sx={{
                          flex: 1,
                          p: 2,
                          pt: 0,
                          overflowY: "auto",
                        }}
                      >
                        {previewTheme === "ProgressCard" && <DummyProgressCard />}
                        {previewTheme === "ProgressCard2" && <DummyProgressCard2 />}
                      </DialogContent>

                      <DialogActions sx={{ justifyContent: "flex-end", p: 1, pt: 0 }}>
                        <Button
                          variant="outlined"
                          onClick={() => setOpenProgressPreview(false)}
                        >
                          Cancel
                        </Button>
                      </DialogActions>
                    </Dialog>

                  </Box>
                ) :
                  selectedMenu === "Attendance Type" ? (

                    <Card
                      sx={{
                        maxWidth: 800,          // a bit wider for the whole row
                        mx: "auto",
                        mt: 4,
                        p: 3,
                        borderRadius: 4,
                        boxShadow: 5,
                        backgroundColor: "#f9f9f9",
                      }}
                    >
                      <CardContent>
                        <Typography variant="h5" fontWeight="bold" gutterBottom>
                          Select Months for Exam Type
                        </Typography>

                        {/* Form row */}
                        <Stack

                          direction={{ xs: "column", sm: "row" }}
                          spacing={2}
                          alignItems="center"
                          sx={{ pt: 2 }}
                        >

                          <TextField
                            select
                            label="Exam Type"
                            value={examType}          // ✅ matches useState variable
                            onChange={(e) => setExamType(e.target.value)}
                            sx={{ flex: 1, minWidth: 150 }}

                          >
                            {monthexamTypes.length > 0 ? (
                              monthexamTypes.map((exam, index) => (
                                <MenuItem key={index} value={exam.Examtype}>
                                  {exam.Examtype}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem disabled>Loading...</MenuItem>
                            )}
                          </TextField>




                          {/* <TextField
                      label="Prefix"
                      value={receiptPrefix}
                      onChange={(e) => setPrefix(e.target.value)}
                      sx={{ flex: 1 }}
                      required
                    /> */}
                          <FormControl sx={{ flex: 1 }}>
                            <InputLabel>Months</InputLabel>
                            <Select
                              multiple
                              value={selectedMonths}       // ✅ matches state
                              onChange={handleChange}
                              label="Months"
                              renderValue={(selected) => selected.join(", ")}
                            >
                              {months.map((month) => (
                                <MenuItem key={month} value={month}>
                                  <Checkbox checked={selectedMonths.indexOf(month) > -1} />
                                  <ListItemText primary={month} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>



                          {/* <TextField
                      label="Sequence Number"
                      type="number"
                      value={startSequence}
                      onChange={(e) => setSequence(e.target.value)}
                      sx={{ flex: 1 }}
                      required
                    /> */}


                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handlemonthSubmit}
                            disabled={monthloading}
                            sx={{
                              minWidth: 120, minHeight: 45, backgroundColor: "#3C3972", '&:hover': {
                                backgroundColor: "#3C3972", // same as normal
                              }
                            }}
                          >
                            {monthloading ? (
                              <CircularProgress size={24} sx={{ color: "#fff" }} />
                            ) : (
                              "Submit"
                            )}
                          </Button>
                        </Stack>
                      </CardContent>

                      {/* --- Table Card --- */}
                      <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 2, // margin bottom
                          }}
                        >
                          {/* Left side - Title */}
                          <Typography
                            variant="h5"
                            sx={{ fontWeight: "bold", color: "#333" }}
                          >
                            Selected Months and Exam Type
                          </Typography>

                          {/* Right side - Dropdown */}
                          {/* <TextField
  select
  label="Exam Type"
  value={filterExamType }
  onChange={(e) => setFilterExamType(e.target.value)}
  sx={{ minWidth: 200 }}
 
  size="small"
>
  {monthexamTypes.length > 0 ? (
    monthexamTypes.map((exam, index) => (
      <MenuItem key={index} value={exam.Examtype}>
        {exam.Examtype}
      </MenuItem>
    ))
  ) : (
    <MenuItem disabled>Loading...</MenuItem>
  )}
</TextField> */}

                        </Box>


                        <GlobalStyles
                          styles={{
                            ".custom-sidebar-scrollbar": {
                              scrollbarWidth: "thin",
                              scrollbarColor: "grey #e0e0e0",
                            },
                            ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                              width: "6px",
                            },
                            ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                              background: "#f1f1f1",
                            },
                            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                              backgroundColor: "grey",
                              borderRadius: "10px",
                            },
                            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                              backgroundColor: "#555",
                            },
                          }}
                        />

                        <TableContainer
                          component={Paper}
                          sx={{
                            borderRadius: 2,
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            maxHeight: "350px",
                            overflow: "auto",
                            mt: 2,
                          }}
                          className="custom-sidebar-scrollbar"
                        >
                          <Table stickyHeader>
                            <TableHead>
                              <TableRow>
                                <TableCell sx={headerStyle}>S.No</TableCell>
                                <TableCell sx={headerStyle}>Months</TableCell>
                                <TableCell sx={headerStyle}>Exam Type</TableCell>
                                <TableCell sx={headerStyle}>Action</TableCell>
                              </TableRow>
                            </TableHead>

                            {reportLoading ? (
                              <TableBody>
                                <TableRow>
                                  <TableCell
                                    colSpan={4}
                                    style={{ textAlign: "center", padding: "20px" }}
                                  >
                                    <Box display="flex" flexDirection="column" alignItems="center">
                                      <CircularProgress />
                                      <Typography variant="body2" sx={{ mt: 1 }}>
                                        Loading Data...
                                      </Typography>
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            ) : monthlyReportsData.length === 0 ? (
                              <TableBody>
                                <TableRow>
                                  <TableCell
                                    colSpan={4}
                                    sx={{ textAlign: "center", padding: "20px" }}
                                  >
                                    No data found
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            ) : (
                              <TableBody>
                                {monthlyReportsData.map((row, index) => (
                                  <TableRow
                                    key={index}
                                    sx={{
                                      backgroundColor: "white",
                                      "&:hover": { backgroundColor: "#f5f5f5" },
                                    }}
                                  >
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ddd",
                                        padding: "6px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {index + 1}
                                    </TableCell>

                                    <TableCell
                                      sx={{
                                        width: 230,
                                        maxWidth: 230,
                                        whiteSpace: "normal",
                                        wordWrap: "break-word",
                                        borderRight: "1px solid #ddd",
                                        padding: "6px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {row.months}
                                    </TableCell>

                                    <TableCell
                                      sx={{
                                        width: 230,
                                        maxWidth: 230,
                                        whiteSpace: "normal",
                                        wordWrap: "break-word",
                                        borderRight: "1px solid #ddd",
                                        padding: "6px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {row.examType}
                                    </TableCell>

                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ddd",
                                        padding: "6px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                                        <Button
                                          variant="contained"
                                          sx={{
                                            backgroundColor: "#1976d2",
                                            color: "white",
                                            minWidth: "60px",
                                            fontSize: "0.75rem",
                                            padding: "3px 8px",
                                            "&:hover": { backgroundColor: "#1565c0" },
                                          }}
                                          size="small"
                                          onClick={() => handleOpenMonthEdit(row)}
                                        >
                                          Edit
                                        </Button>

                                        <Button
                                          variant="contained"
                                          sx={{
                                            backgroundColor: "#a82814",
                                            color: "#fff",
                                            minWidth: "60px",
                                            fontSize: "0.75rem",
                                            padding: "3px 8px",
                                            "&:hover": { backgroundColor: "#7a1b0e" },
                                          }}
                                          size="small"
                                          onClick={() => handleRemoveMonthRow(row)}
                                        >
                                          Delete
                                        </Button>
                                      </Box>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            )}
                          </Table>
                        </TableContainer>
                      </Paper>


                      {/* --- Edit Modal --- */}
                      {isMonthEditOpen && selectedMonthRow && (
                        <Modal open={isMonthEditOpen} onClose={() => setIsMonthEditOpen(false)}>
                          <Box
                            sx={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              width: 500,
                              bgcolor: "background.paper",
                              boxShadow: 24,
                              p: 3,
                              borderRadius: 2,
                            }}
                          >
                            <Typography variant="h5" fontWeight="bold" mb={2}>
                              Edit Month & Exam Type
                            </Typography>

                            <Stack spacing={2}>
                              {/* Exam Type Dropdown */}
                              <TextField
                                select
                                label="Exam Type"
                                value={editMonthExamType}
                                onChange={(e) => setEditMonthExamType(e.target.value)}
                                fullWidth
                              >
                                {monthexamTypes.map((exam, idx) => (
                                  <MenuItem key={idx} value={exam.Examtype}>
                                    {exam.Examtype}
                                  </MenuItem>
                                ))}
                              </TextField>

                              {/* Months Multi-Select */}
                              <FormControl fullWidth>
                                <InputLabel>Months</InputLabel>
                                <Select
                                  multiple
                                  label="Months"
                                  value={editMonthMonths}
                                  onChange={(e) => setEditMonthMonths(e.target.value)}
                                  renderValue={(selected) => selected.join(", ")}
                                >
                                  {months.map((month) => (
                                    <MenuItem key={month} value={month}>
                                      <Checkbox checked={editMonthMonths.indexOf(month) > -1} />
                                      <ListItemText primary={month} />
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>

                              {/* Actions */}
                              <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                                <Button
                                  variant="outlined"
                                  onClick={() => setIsMonthEditOpen(false)}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  variant="contained"
                                  sx={{ backgroundColor: "#3C3972", color: "white" }}
                                  onClick={() => {
                                    const updatedRow = {
                                      ...selectedMonthRow,
                                      examType: editMonthExamType,
                                      months: editMonthMonths,
                                    };
                                    handleUpdateMonthRow(updatedRow); // call your update function here
                                  }}
                                  disabled={isUpdatingMonth}
                                >
                                  {isUpdatingMonth ? (
                                    <CircularProgress size={20} sx={{ color: "white" }} />
                                  ) : (
                                    "Save"
                                  )}
                                </Button>
                              </Box>
                            </Stack>
                          </Box>
                        </Modal>
                      )}


                    </Card>




                  )
                    : (
                      <Typography variant="body1" color="text.secondary">
                        This feature is coming soon. Stay tuned!
                      </Typography>
                    )
            }

          </Box>
        </Box>
      </Card>

      <ToastContainer position="top-right" autoClose={2000} />
    </Box>
  );
};

export default Settings;